/* eslint-disable */
import React from 'react';
import compose from 'lodash/fp/compose';
import {
  withTranslation,
  withCustomRouter,
  withUserPreferences,
  withWorkAbsenceInfo,
} from 'components/hoc';
import MyDataContentTemplate from 'components/Dashboard/MyData/common/MyDataContentTemplate';
import LottieLoader from 'components/common/LottieLoader';
import { getFullName } from "components/utils";

const WorkAbsence = (props) => {
  const truncate = (name) => name && name.length > 25 ? `${name.substring(0, 25)}...` : name;

  const mapFields = () => {
    const { workAbsenceInfo, fd, trObj } = props;

    return workAbsenceInfo.data.map((data) => {
      return {
        ...data,
        person: getFullName(data?.person_detail),
        valid_from: fd(data?.valid_from),
        valid_to: fd(data?.valid_to),
        organisation: truncate(data?.organisation_detail?.name),
        industry: truncate(trObj(data?.organisation_detail?.industry_type_detail)),
        absence_type: trObj(data?.absence_type_detail),
      };
    });
  };

  const { loaded, deleteBulkWorkAbsence, gotoCreatePath } = props;

  // Add filterableColumns configuration
  const filterableColumns = [
 
    {
      columnId: 'person',
      columnDataType: 'text',
    },
    {
        columnId: 'organisation',
        columnDataType: 'text',
      },
    {
      columnId: 'valid_from',
      columnDataType: 'date',
    },
    {
      columnId: 'valid_to',
      columnDataType: 'date',
    },
    {
        columnId: 'absence_type',
        columnDataType: 'text',
    },
      {
        columnId: 'comment',
        columnDataType: 'text',
      },
  ];

  if (!loaded) {
    return (
      <>
        <LottieLoader />
      </>
    );
  }

  return (
    <MyDataContentTemplate
      tableName="work_absence"
      columns={[]}
      data={mapFields()}
      handleCreateForm={gotoCreatePath}
      bulkDelete={deleteBulkWorkAbsence}
      filterableColumns={filterableColumns}
    />
  );
};

export default compose(
  withTranslation,
  withWorkAbsenceInfo,
  withCustomRouter,
  withUserPreferences,
)(WorkAbsence);
